import React from "react";
//import styled from "styled-components";
import SignupTemplate from "../../templates/Signup";

const Signup: React.FunctionComponent = () => <SignupTemplate />;

export default Signup;
